var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-6 text-center text-[10px] leading-4 text-secondary-400",class:{ 'bg-white': _vm.isLogin }},[_vm._v(" @中国移动通信集团江苏有限公司版权所有 "),_c('br'),_vm._v(" 苏ICP备11070397号-21 "),_c('br'),_vm._v(" (中国移动通信集团委托江苏有限公司支撑XXXX全网平台) ")])
}
var staticRenderFns = []

export { render, staticRenderFns }